let getTokenRef: (() => string | null) | null = null;
let onAuthFailureRef: (() => void) | null = null;

export function configureAuthFetch(getToken: () => string | null, onAuthFailure: () => void): void {
  getTokenRef = getToken;
  onAuthFailureRef = onAuthFailure;
}

/** 401 drops the session. 403 is returned untouched: the caller shows "sem permissão". */
export async function authFetch(url: string, options: RequestInit = {}): Promise<Response> {
  const token = getTokenRef?.();
  const headers = new Headers(options.headers);
  if (token) headers.set("Authorization", `Bearer ${token}`);
  const response = await fetch(url, { ...options, headers });
  if (response.status === 401) onAuthFailureRef?.();
  return response;
}
